import { mapActions, mapGetters } from 'vuex'
import VueJsonPretty from 'vue-json-pretty'

export default {
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  components: {
    VueJsonPretty
  },
  data () {
    return {
      rules: {
        mock: () => (!this.mock || !!this.isValidJSONString) || 'O JSON informado não é válido'
      },
      mock: null,
      viewMock: false,
      name: '',
      dialog: false,
      fieldName: '',
      paramName: '',
      paramValue: '',
      requestField: '',
      paramsFields: [],
      fieldsAvailable: [],
      requestFields: [],
      minimumPrice: null,
      cost: null,
      description: '',
      idFieldType: false,
      isLoading: false,
      providerSources: [],
      providerClassification: [],
      selectedProviderSources: '',
      selectedProviderClassification: '',
      providerTypes: [
        { name: 'PF', value: 'PF' },
        { name: 'PJ', value: 'PJ' },
        { name: 'Outro', value: null }
      ],
      selectedType: '',
      typeField: [
        {
          name: 'Sim',
          id: true
        },
        {
          name: 'Não',
          id: false
        }
      ],
      metrics: [
        { name: 'Alto', value: '5ba98593-3fa1-40b3-b773-6a0a25f8931a' },
        { name: 'Baixo', value: '8b322de6-61d2-487a-bd93-fee10f480334' },
        { name: 'Local', value: '63c68219-d34c-43d9-98e7-82595e1c05df' }
      ],
      selectedMetrics: ''
    }
  },
  computed: {
    ...mapGetters([
      'getterSelectedSystemProvider',
      'getterPlanType',
      'getterSources'
    ]),
    isDisabledButton () {
      return !this.name || (this.mock && !this.isValidJSONString) || this.fieldsAvailable.length === 0 || this.requestFields.length === 0 || !this.minimumPrice || !this.cost || this.selectedType === '' || this.selectedMetrics === ''
    },
    isValidJSONString () {
      let result = null

      try {
        result = JSON.parse(this.mock)
      } catch (e) {
        result = null
      }

      return result
    },
    options () {
      return {
        loading: this.isLoading
      }
    }
  },
  mounted () {
    this.dialog = true

    this.getSystemProviderClassification()
    this.getSources()
  },
  methods: {
    ...mapActions([
      'actionGetSources',
      'actionGetSystemProviderClassifications',
      'actionAddSystemProvider'
    ]),

    getSources () {
      this.actionGetSources().then((response) => {
        this.providerSources = response.data.map((item) => ({
          label: item.sourceName,
          value: item.idSource
        }))
      }).catch((error) => {
        console.log(error)
        this.isLoading = false
      })
    },

    async getSystemProviderClassification () {
      this.actionGetSystemProviderClassifications().then((response) => {
        this.providerClassification = response.data.map((item) => ({
          label: item.name,
          value: item.idSystemProviderClassification
        }))
      }).catch((error) => {
        console.log(error)
      })
    },
    addFieldAvailable () {
      const fieldAvailable = {
        name: this.fieldName
      }

      if (this.fieldName !== '') {
        this.fieldsAvailable.push(fieldAvailable)
        this.fieldName = ''
      }
    },
    removeFieldAvailable (item) {
      this.fieldsAvailable.splice(this.fieldsAvailable.indexOf(this.fieldsAvailable.find((c) => c.idFieldAvaliableOnProvider === item.idFieldAvaliableOnProvider)), 1)
    },
    addParamField () {
      const paramField = {
        name: this.paramName,
        value: this.paramValue
      }

      if (this.paramName !== '' && this.paramValue !== '') {
        this.paramsFields.push(paramField)
        this.paramName = ''
        this.paramValue = ''
      }
    },
    removeParamField (item) {
      this.paramsFields.splice(this.paramsFields.indexOf(this.paramsFields.find((c) => c.idParamsField === item.idParamsField)), 1)
    },
    addRequestField () {
      const requestField = {
        name: this.requestField,
        required: false,
        internal: this.idFieldType
      }

      if (this.requestField !== '') {
        this.requestFields.push(requestField)
        this.requestField = ''
        this.idFieldType = false
      }
    },
    removeRequestField (item) {
      this.requestFields.splice(this.requestFields.indexOf(this.requestFields.find((c) => c.idRequestField === item.idRequestField)), 1)
    },
    addProvider () {
      if (!this.isDisabledButton) {
        const systemProvider = {
          type: this.selectedType,
          name: this.name,
          fieldsAvaliableOnProvider: this.fieldsAvailable,
          paramsFields: this.paramsFields,
          requestFields: this.requestFields,
          minimumPrice: !this.minimumPrice ? 0 : parseFloat(this.minimumPrice.toString().replace('.', '').replace(',', '.')),
          cost: !this.cost ? 0 : parseFloat(this.cost.toString().replace('.', '').replace(',', '.')),
          description: this.description,
          mock: this.mock,
          sourceName: this.selectedProviderSources || '',
          idSystemProviderClassification: this.selectedProviderClassification || '',
          metricTypeId: this.selectedMetrics || '',
          idSource: this.selectedProviderSources || ''
        }

        this.isLoading = true

        this.actionAddSystemProvider(systemProvider)
          .then(() => {
            this.sendToast({
              text: 'Provider adicionado com sucesso',
              type: 'success'
            })

            this.closeModal()
          })
          .catch((err) => {
            if (err && err.status && err.status === 409) {
              this.sendToast({
                text: 'Este nome de provider já consta cadastrado',
                type: 'warning'
              })
            } else {
              this.sendToast({
                text: 'Não foi possível salvar este provider',
                type: 'danger'
              })
            }

            this.isLoading = false
          })
      } else {
        this.sendToast({
          text: 'Os campos não foram preenchidos corretamente!',
          type: 'warning'
        })
      }
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    toogleCheckbox (item, index) {
      this.requestFields[index].required = item.required
    }
  }
}
